import { Helmet } from "react-helmet-async";
import titleFace from "@/assets/fonts/sheet/fira-xcond-black.woff2";
import textFace from "@/assets/fonts/sheet/golos-text-var.woff2";

/*
  Both One Sheet faces, fetched with the page on every route rather than when a
  stylesheet first asks for them: the title face sets the first thing anyone
  reads, on the landing and in /y alike, and without this the fallback flashes
  in its place. Each file is subset to Latin + Cyrillic.
*/
export function FontPreload() {
  return (
    <Helmet>
      <link rel="preload" as="font" type="font/woff2" href={titleFace} crossOrigin="anonymous" />
      <link rel="preload" as="font" type="font/woff2" href={textFace} crossOrigin="anonymous" />
    </Helmet>
  );
}
